import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LoadOcpsPolicyDataAction } from '../../domains/ocps/actions.types';

import { OcpsPolicyLifecycle } from './types';

export type { LoadOcpsPolicyDataAction };

const initialState: OcpsPolicyLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<OcpsPolicyLifecycle, LoadOcpsPolicyDataAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'OCPS_POLICIES.LOAD_PENDING':
      return setPending();
    case 'OCPS_POLICIES.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'OCPS_POLICIES.LOAD_REJECTED':
      return setRejected(action.payload);
    case 'OCPS_POLICIES.CLEAR':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
